import Button from 'antd/lib/button'
import { useMemo } from 'react'
import classes from './ActionButton.module.less'

export type ActionButtonPropsType = {
    icon?: React.FC<{ color: string }>
    title: string | JSX.Element
    onClick?: React.MouseEventHandler<HTMLElement>
    color?: 'primary' | 'default' | 'danger'
    disabled?: boolean
    iconPosition?: 'start' | 'end'
    style?: React.CSSProperties
    className?: CSSModuleClasses[string]
}

export const ActionButton: React.FC<ActionButtonPropsType> = ({
    icon: Icon,
    title,
    onClick,
    color = 'primary',
    disabled = false,
    iconPosition = 'start',
    className,
    ...restProps
}: ActionButtonPropsType) => {
    const buttonClasses = useMemo(() => {
        const classesList = []
        if (color === 'primary') {
            classesList.push(classes.primary)
        } else if (color === 'default') {
            classesList.push(classes.default)
        } else if (color === 'danger') {
            classesList.push(classes.danger)
        }

        if (className) {
            classesList.push(className)
        }
        return classesList.join(' ')
    }, [className, color])

    return (
        <Button
            data-testid="action-button-wrapper"
            {...restProps}
            color={['primary', 'default', 'danger'].includes(color) ? color : undefined}
            className={buttonClasses}
            icon={
                Icon ? (
                    <Icon color={color === 'default' || disabled ? '#00000040' : '#fff'} />
                ) : undefined
            }
            onClick={onClick}
            style={{
                ...(restProps.style ?? {}),
                background: ['primary', 'secondary'].includes(color ?? '') ? undefined : color,
            }}
            disabled={disabled || false}
            iconPosition={iconPosition ?? 'start'}
        >
            {title}
        </Button>
    )
}
